"use client";
import Image from "next/image";

export default function PricingTransparency() {
  return (
    <section className="relative bg-white py-16 pb-20 px-6">
      <div className="mx-auto max-w-[1348px] grid grid-cols-1 gap-20 lg:grid-cols-2">
        {/* Left Card (Image/Features) */}
        <div className="relative flex flex-col items-center justify-center gap-6 rounded-3xl border border-[#ceddff] bg-gradient-to-tr from-white to-[#f4f7ff] p-8 order-2 lg:order-1">
          <div className="relative z-10 w-full">
            <div className="flex gap-4 overflow-x-auto sm:grid sm:grid-cols-3 sm:gap-10 no-scrollbar">
              {/* Card 1 */}
              <div className="min-w-[140px] sm:min-w-0 flex-shrink-0 flex flex-col items-center justify-center rounded-2xl border border-[#e9d5ff] bg-gradient-to-br from-purple-500/10 to-pink-500/10 p-4 sm:p-6">
                <Image
                  src="/Integra-ai/f1.png"
                  alt="No Markup"
                  width={48}
                  height={48}
                  className="h-8 w-8 sm:h-12 sm:w-12 object-contain"
                />
                <p className="mt-2 text-center text-sm sm:text-base font-medium text-purple-400">
                  No Markup
                </p>
              </div>

              {/* Card 2 */}
              <div className="min-w-[140px] sm:min-w-0 flex-shrink-0 flex flex-col items-center justify-center rounded-2xl border border-[#fbcfe8] bg-gradient-to-br from-pink-500/10 to-orange-500/10 p-4 sm:p-6">
                <Image
                  src="/Integra-ai/f2.png"
                  alt="BYOK Model"
                  width={48}
                  height={48}
                  className="h-8 w-8 sm:h-12 sm:w-12 object-contain"
                />
                <p className="mt-2 text-center text-sm sm:text-base font-medium text-pink-400">
                  BYOK Model
                </p>
              </div>

              {/* Card 3 */}
              <div className="min-w-[140px] sm:min-w-0 flex-shrink-0 flex flex-col items-center justify-center rounded-2xl border border-[#fed7aa] bg-gradient-to-br from-orange-500/10 to-yellow-500/10 p-4 sm:p-6">
                <Image
                  src="/Integra-ai/f3.png"
                  alt="Self-Hosted"
                  width={48}
                  height={48}
                  className="h-8 w-8 sm:h-12 sm:w-12 object-contain"
                />
                <p className="mt-2 text-center text-sm sm:text-base font-medium text-orange-500">
                  Self-Hosted <br /> Options
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Right Content */}
        <div className="flex flex-col justify-center text-center lg:text-left order-1 lg:order-2">
          <h2 className="text-3xl font-bold leading-[135%] text-[#222] sm:text-4xl">
            Transparent, Fair Pricing.
          </h2>
          <p className="mt-4 text-base leading-relaxed text-[#7d7b7b] sm:text-lg">
            Unlike other platforms that mark up AI provider costs or hide fees,
            Integra AI focuses on delivering value through our platform while
            keeping your AI spending transparent and under your control.
          </p>
          <p className="mt-2 text-base leading-relaxed text-[#7d7b7b] sm:text-lg">
            <span className="font-semibold">Our philosophy:</span> You
            shouldn&apos;t pay twice for AI access and your direct relationship
            with AI vendors should be maintained.
          </p>
        </div>
      </div>
    </section>
  );
}
